import { UserDataEntity } from '@medlinker/data-tracker/browser';
import MedDT from '@medlinker/data-tracker/browser';
import sensors from 'sa-sdk-javascript';
import { EventVariables } from '../variables';
// import { getEventId } from '../utils';

/**
 * 事件追踪函数
 *
 * @template T 事件变量
 * @param { string } id 事件 ID
 * @param { EventVariables } variables 事件变量
 * @param { UserDataEntity} [medTrackerOptions] medDataTracker 参数配置
 */
/*****************************
 *      埋点声明区域 Start    */

/** 示例 */
export function track(
  /** 事件 ID 示例 */
  id: 'demoEventId',
  variables: {
    /** 事件变量示例 */
    title: string;
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 点击添加购物车按钮埋点 */
export function track(
  id: 'clickAddToCartButton',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 复购二期-再次购买选择开药方式弹窗-view */
export function track(
  id: 'mall_h5_re_purchase_select_way_view',
  variables: { page: string },
  medTrackerOptions?: UserDataEntity
): void;
/** 复购二期-再次购买选择开药方式弹窗-极速购药（开药门诊）点击-click */
export function track(
  id: 'mall_h5_re_purchase_quick_buy_click',
  variables: { page: string },
  medTrackerOptions?: UserDataEntity
): void;
/** 复购二期-再次购买选择开药方式弹窗-问诊开药（随诊）点击-click */
export function track(
  id: 'mall_h5_re_purchase_physician_prescribing_click',
  variables: { page: string },
  medTrackerOptions?: UserDataEntity
): void;
/** 复购三期-确认处方弹窗-view */
export function track(
  id: 'repurchaseThreePrescriptionModal',
  variables: { prescriptionId: string },
  medTrackerOptions?: UserDataEntity
): void;
/** 复购三期-确认处方弹窗-确认 click */
export function track(
  id: 'repurchaseThreePrescriptionModalConfirm',
  variables: { prescriptionId: string },
  medTrackerOptions?: UserDataEntity
): void;
/** 复购三期-确认处方弹窗-有效点击确认 click */
export function track(
  id: 'repurchaseThreePrescriptionModalRealConfirm',
  variables: { prescriptionId: string },
  medTrackerOptions?: UserDataEntity
): void;

/** 复购三期-确认处方弹窗-取消 click */
export function track(
  id: 'repurchaseThreePrescriptionModalCancel',
  variables: { prescriptionId: string },
  medTrackerOptions?: UserDataEntity
): void;
/** 复购三期-确认处方弹窗-更换处方 click */
export function track(
  id: 'repurchaseThreePrescriptionModalChange',
  variables: { prescriptionId: string },
  medTrackerOptions?: UserDataEntity
): void;
/** 复购三期-选择开药处方list view */
export function track(
  id: 'repurchaseThreePrescriptionModalList',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 复购三期-选择开药处方list-选择处方 click */
export function track(
  id: 'repurchaseThreePrescriptionModalChoose',
  variables: {
    prescriptionId: string;
    /**
     * 是否是默认卡片点击
     * default: 默认卡片
     * notDefault: 非默认卡片
     */
    action: string;
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 确认药品信息弹窗【发送购药申请】按钮点击 */
export function track(
  id: 'clickSubmitButtonInReBuyDrugInfoModal',
  variables: {
    prescriptionId: string;
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 确认药品信息弹窗【再想想】按钮点击 */
export function track(
  id: 'clickCancelButtonInReBuyDrugInfoModal',
  variables: {
    prescriptionId: string;
  },
  medTrackerOptions?: UserDataEntity
): void;
/**
 * 复诊购药流程入口点击
 */
export function track(
  id: 'clickRepurchaseMedicineStart',
  variables: Record<string, any> & {
    content_id: string; // 1：处方列表 2：医生卡片 3：订单详情 4：客服页面 5：订单列表 6：首页再次购买
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 医生主页 / 随诊诊室页面 复诊开药 */
export function track(
  id: 'mall_h5_continue_prescription_click',
  variables: {
    title: string; // 医生主页 随诊诊室页面
    path: string; // 页面路径
    channel: string; // 渠道
    doctorId: string; // 医生id
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 确认药品信息弹窗曝光事件 */
export function track(
  id: 'viewConfirmDrugInfoModal',
  variables: {
    prescriptionId: string;
  },
  medTrackerOptions?: UserDataEntity
): void;
/* 用户点击复诊开药 */
export function track(
  id: 'mall_h5_repurchase_order_repuchase_click',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/* 用户点击再次购买 */
export function track(
  id: 'mall_h5_repurchase_order_rebuy_click',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 药品详情页（选择开药方式）- 弹窗曝光 */
export function track(
  id: 'mall_h5_select_prescribe_method_view',
  variables: {
    action: string;
    channel: string;
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 药品详情页（选择开药方式）- 极速开药（开药门诊）点击埋点 */
export function track(
  id: 'mall_h5_outpatient_buy_now_click',
  variables: {
    action: string;
    channel: string;
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 随诊医生列表 医生点击 */
export function track(
  id: 'mall_h5_follow_up_select_doctor_click',
  variables: {
    action: string;
    channel: string;
  },
  medTrackerOptions?: UserDataEntity
): void;

/*用药信息页面*/
export function track(
  id: 'mall_h5_repurchase_order_patient',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 预约单页面 */
export function track(
  id: 'mall_h5_repurchase_order_view',
  variables: { prescriptionId: string },
  medTrackerOptions?: UserDataEntity
): void;
/** 提交预约单 */
export function track(
  id: 'mall_h5_repurchase_button_click',
  variables: { prescriptionId: string },
  medTrackerOptions?: UserDataEntity
): void;
/** 选择曾用处方 */
export function track(
  id: 'mall_h5_repurchase_order_choose_pr',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 预约单中立即咨询 */
export function track(
  id: 'mall_h5_repurchase_order_consult_click',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 确任使用预约单服务 */
export function track(
  id: 'mall_h5_repurchase_order_protocol_check',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 客服咨询页查看更多物流信息 */
export function track(
  id: 'mall_h5_consult_logistics_click',
  variables: {
    content_id?: string; // 订单号
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 客服咨询页查看全部订单 */
export function track(
  id: 'mall_h5_consult_orders_click',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 客服咨询页确认收货 */
export function track(
  id: 'mall_h5_consult_confirm_click',
  variables: {
    content_id?: string; // 订单号
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 客服咨询页提醒收货 */
export function track(
  id: 'mall_h5_consult_prompt_click',
  variables: {
    content_id?: string; // 订单号
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 客服咨询页再次购买 */
export function track(
  id: 'mall_h5_consult_rebuy_click',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 客服咨询页前往慢病药房购置药品 */
export function track(
  id: 'mall_h5_consult_mall_click',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 客服咨询页寻找医生开置处方 */
export function track(
  id: 'mall_h5_consult_message_click',
  variables: Record<string, never>,
  medTrackerOptions?: UserDataEntity
): void;
/** 客服咨询页问题点击埋点 */
export function track(
  id: 'mall_h5_consult_question_click',
  variables: {
    content_id?: string; // 点击的问题id
    action?: string; // 点击的问题内容
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 客服咨询页输入框上方标签埋点点击埋点 */
export function track(
  id: 'mall_h5_consult_tag_click',
  variables: {
    content_id?: string; // 点击的问题id
    action?: string; // 点击的问题内容
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 订单-开发票-发票类型选择 */
export function track(
  id: 'mall_h5_order_invoice_type_select_click',
  variables: {
    content_id: '0' | '1' | '2'; // 点击选择的发票类型（0：不开 1：纸质 2：电子）
    page: string; // 页面
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 订单列表 / 详情-开发票及编辑发票-点击 */
export function track(
  id: 'mall_h5_order_invoice_edit_btn_click',
  variables: {
    content_id: '0' | '1'; // 点击选择的发票类型（0：开发票 1：编辑发票）
    page: string; // 页面
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 用药建议 / 处方详情页面点击 申请购药 按钮 */
export function track(
  id: 'mall_h5_prescription_go_buy_click',
  variables: {
    content_id: string; // 1：用药建议 2：处方
    prescriptionId: string; // 用药建议 / 处方id
    page: string; // 页面地址
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 用药建议详情页面浏览 */
export function track(
  id: 'mall_h5_suggest_detail_view',
  variables: {
    content_id: string; // 类型： 1、患者购药申请 2、患者复购申请 3、医生开方
    prescriptionId: string; // 用药建议id
    from: string; // 标记页面来源1、im诊室卡片 2、微信推送通知
    page: string; // 页面地址
    channel: string; // 渠道
  },
  medTrackerOptions?: UserDataEntity
): void;
/** 处方详情页面浏览 */
export function track(
  id: 'mall_h5_prescription_detail_view',
  variables: {
    content_id: string; // 类型： 1、患者购药申请 2、患者复购申请 3、医生开方
    prescriptionId: string; // 处方id
    from: string; // 标记页面来源1、im诊室卡片 2、微信推送通知
    page: string; // 页面地址
    channel: string; // 渠道
  },
  medTrackerOptions?: UserDataEntity
): void;

/** 默认声明 */
export function track(
  id: string,
  variables: Record<string, any>,
  medTrackerOptions?: UserDataEntity
): void;

/*      埋点声明区域 End      *
 *****************************/

// track 函数实现
export function track(
  id: string,
  variables: EventVariables,
  medTrackerOptions?: UserDataEntity
): void {
  // const eventId = getEventId(id);

  sensors.track(id, variables);
  // if (gioIsValid()) {
  //   window.gio('track', eventId, variables);
  // }

  if (medTrackerOptions) {
    MedDT.collect(medTrackerOptions);
  }
}
